import React, { useEffect } from 'react'
import { CustomRow } from './style'
import { compose } from 'redux'
import { reducer } from './slices'
import injectReducer from 'utils/injectReducer'
import Help from './components/Help'
import Form from './components/Form'
import Layout from 'components/Layout'
import { getTermsReq, getPolicyReq } from 'containers/Login/thunk'
import { useDispatch, useSelector } from 'react-redux'
import MessageCookieOff from '../../components/MessageCookieOff'
import { postWindowMessage } from 'utils/common'

const Login = ({ match }) => {
	const dispatch = useDispatch()
	const {
		shopId,
		locale,
		wrapperUrl,
		orderId,
		email,
		currentTheme,
		managerUsername,
	} = useSelector((state) => state.root)
	const checkCookie = () => {
		let cookieEnabled = navigator.cookieEnabled
		if (!cookieEnabled) {
			document.cookie = 'returnadotestcookie'
			cookieEnabled =
				document.cookie.indexOf('returnadotestcookie') !== -1
		}
		return cookieEnabled
	}

	useEffect(() => {
		if (wrapperUrl) postWindowMessage(wrapperUrl, match.path)
		if (shopId) {
			dispatch(getTermsReq(shopId, locale))
			dispatch(getPolicyReq(shopId, locale))
		}
	}, [shopId, locale])

	return (
		<Layout path={match.path}>
			{checkCookie() ? (
				<CustomRow className='row'>
					<Help />
					<Form
						orderId={orderId}
						email={email}
						shopId={shopId}
						locale={locale}
						themeName={currentTheme?.name}
						managerUsername={managerUsername}
					/>
				</CustomRow>
			) : (
				<>
					<MessageCookieOff />
				</>
			)}
		</Layout>
	)
}

export default compose(injectReducer({ key: 'login', reducer }))(Login)
